/* DREAM Shipping Protection: added once per bag; shoppers can switch it off in the bag. */
window.drEnsureProtection=()=>{
  const root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/',H='dream-shipping-protection',VID=48232944468022;
  return fetch(root+'cart.js',{headers:{Accept:'application/json'}}).then(r=>r.json()).then(c=>{
    if((c.attributes||{})._dr_protection==='off')return;
    if(c.items.some(i=>i.handle===H))return;
    if(!c.items.some(i=>i.handle!==H))return;
    return fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:VID,quantity:1}]})});
  }).catch(()=>{});
};
/* DREAM: native form transactions; no fetch interception, no competing drawer. */
(()=>{
  'use strict';
  const init=(scope=document)=>{
    scope.querySelectorAll('[data-dr-product]:not([data-dr-ready])').forEach(root=>{
      root.dataset.drReady='true';
      const form=root.querySelector('[data-dr-form]'),select=root.querySelector('[data-dr-variant]'),button=root.querySelector('[data-dr-submit]'),error=root.querySelector('[data-dr-error]');
      const variants=JSON.parse(root.querySelector('[data-dr-variants]').textContent);
      const currency=root.dataset.currency||'USD',locale=root.dataset.locale||'en';
      const money=cents=>new Intl.NumberFormat(locale,{style:'currency',currency}).format(cents/100);
      const showMedia=id=>{root.querySelectorAll('[data-media-id]').forEach(p=>p.hidden=p.dataset.mediaId!==String(id));root.querySelectorAll('[data-dr-media]').forEach(b=>b.setAttribute('aria-pressed',b.dataset.drMedia===String(id)));};
      root.querySelectorAll('[data-dr-media]').forEach(b=>b.addEventListener('click',()=>showMedia(b.dataset.drMedia)));
      const options=root.querySelector('[data-dr-options]');
      if(variants.length>1){options.hidden=false;select.classList.add('dr-visually-hidden');}
      const update=()=>{
        const variant=variants.find(v=>String(v.id)===select.value);
        root.querySelectorAll('[data-dr-choose]').forEach(b=>b.setAttribute('aria-pressed',b.dataset.drChoose===select.value));
        error.textContent='';
        const selection=root.querySelector('[data-dr-selection]');
        if(selection){selection.textContent=variant?selection.dataset.selectedLabel+' '+variant.title:selection.dataset.unselectedLabel;selection.classList.toggle('dr-has-selection',Boolean(variant));}
        button.disabled=variant?!variant.available:!variants.some(v=>v.available);
        button.querySelector('span').textContent=variant?(variant.available?button.dataset.label:button.dataset.sold):button.dataset.select;
        const dynamic=root.querySelector('[data-dr-dynamic]');if(dynamic)dynamic.hidden=!(variant&&variant.available);
        if(!variant)return;
        root.querySelector('[data-dr-price]').textContent=money(variant.price);
        root.querySelector('[data-dr-compare]').textContent=variant.compare_at_price>variant.price?money(variant.compare_at_price):'';
        if(variant.featured_media)showMedia(variant.featured_media.id);
        else if(variant.featured_image){const panel=[...root.querySelectorAll('[data-media-id]')].find(p=>p.querySelector('img')?.src.includes(variant.featured_image.src.split('?')[0].split('/').pop()));if(panel)showMedia(panel.dataset.mediaId);}
        const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState(null,'',url);
      };
      root.querySelectorAll('[data-dr-choose]').forEach(b=>b.addEventListener('click',()=>{select.value=b.dataset.drChoose;select.dispatchEvent(new Event('change',{bubbles:true}));}));
      select.addEventListener('change',update);
      select.addEventListener('invalid',e=>{if(options.hidden)return;e.preventDefault();error.textContent=button.dataset.select;options.querySelector('button:not(:disabled)')?.focus();});
      form.addEventListener('submit',e=>{
        const variant=variants.find(v=>String(v.id)===select.value);
        if(!variant?.available){e.preventDefault();error.textContent=button.dataset.select;options.querySelector('button:not(:disabled)')?.focus();return;}
        // Only this new form is owned here. Do not disable the Vitals app or its offers.
        e.stopImmediatePropagation();
        button.disabled=true;button.setAttribute('aria-busy','true');if(button.dataset.adding)button.querySelector('span').textContent=button.dataset.adding;
        HTMLFormElement.prototype.submit.call(form);
      },true);
      update();
    });
    scope.querySelectorAll('[data-dr-sort]:not([data-dr-ready])').forEach(select=>{select.dataset.drReady='true';select.addEventListener('change',()=>select.form.requestSubmit());});
    scope.querySelectorAll('[data-dr-cart]:not([data-dr-ready])').forEach(form=>{
      form.dataset.drReady='true';
      form.addEventListener('change',()=>{
        form.dataset.dirty='true';
        // Native checkout submission includes every updates[] and the note.
        // It cannot run an out-of-date async cart request behind the checkout click.
      });
      form.addEventListener('submit',e=>{
        if(form.dataset.submitting){e.preventDefault();return;}
        form.dataset.submitting='true';
        e.stopImmediatePropagation();
        form.setAttribute('aria-busy','true');
      },true);
    });
  };
  document.addEventListener('DOMContentLoaded',()=>{
    init();
    // Only measure the visible Shopify preview toolbar. Do not alter consent or app state.
    let bar,resizeObserver,scheduled=false;
    const sync=()=>{
      scheduled=false;
      const found=document.getElementById('PBarNextFrameWrapper');
      if(found!==bar){
        resizeObserver?.disconnect();bar=found;
        if(bar&&window.ResizeObserver){resizeObserver=new ResizeObserver(schedule);resizeObserver.observe(bar);}
      }
      const rect=bar?.getBoundingClientRect();
      const visible=rect&&rect.width>0&&rect.height>0&&getComputedStyle(bar).display!=='none'&&getComputedStyle(bar).visibility!=='hidden';
      const height=visible?Math.max(0,Math.min(rect.height,innerHeight-rect.top)):0;
      document.documentElement.style.setProperty('--dr-preview-offset',Math.ceil(height)+'px');
    };
    const schedule=()=>{if(!scheduled){scheduled=true;requestAnimationFrame(sync);}};
    new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true});
    window.addEventListener('resize',schedule,{passive:true});
    schedule();
  });
  document.addEventListener('shopify:section:load',e=>init(e.target));
  const submitProduct=(form,e)=>{
    e.preventDefault();e.stopImmediatePropagation();
    const button=form.querySelector('[data-dr-submit]');
    if(button.disabled||form.dataset.submitting)return;
    if(!form.reportValidity())return;
    form.dataset.submitting='true';button.disabled=true;button.setAttribute('aria-busy','true');if(button.dataset.adding)button.querySelector('span').textContent=button.dataset.adding;
    // DREAM: add through the Cart API so Shopify sends add-to-cart to Meta, Google and GA4, then open the cart as before.
    const error=form.querySelector('[data-dr-error]');
    const reset=message=>{delete form.dataset.submitting;button.disabled=false;button.removeAttribute('aria-busy');button.querySelector('span').textContent=button.dataset.label;if(error&&message)error.textContent=message;};
    const destination=form.querySelector('[name="return_to"]')?.value||'/cart';
    const root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
    fetch(root+'cart/add.js',{method:'POST',headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:new FormData(form)})
      .then(r=>r.json().catch(()=>({})).then(data=>({ok:r.ok,data})))
      .then(({ok,data})=>{
        if(!ok){reset(data.description||data.message||button.dataset.select);return;}
        window.drEnsureProtection().finally(()=>setTimeout(()=>location.assign(destination),500));
      })
      .catch(()=>HTMLFormElement.prototype.submit.call(form));
  };
  const submitCart=(form,button,e)=>{
    e.preventDefault();e.stopImmediatePropagation();
    if(form.dataset.submitting||!form.reportValidity())return;
    if(button?.name){const marker=document.createElement('input');marker.type='hidden';marker.name=button.name;marker.value=button.value||'1';form.append(marker);}
    form.dataset.submitting='true';form.setAttribute('aria-busy','true');
    HTMLFormElement.prototype.submit.call(form);
  };
  window.addEventListener('submit',e=>{if(e.target.matches('[data-dr-form]'))submitProduct(e.target,e);else if(e.target.matches('[data-dr-cart]'))submitCart(e.target,e.submitter,e);},true);
  window.addEventListener('click',e=>{
    // DREAM: pick the size here first; size taps stop here so the Vitals app does not treat them as add-to-cart clicks.
    const choose=e.target.closest('[data-dr-choose]');
    if(choose){e.stopImmediatePropagation();if(choose.disabled)return;const select=choose.closest('[data-dr-product]')?.querySelector('[data-dr-variant]');if(select&&select.value!==choose.dataset.drChoose){select.value=choose.dataset.drChoose;select.dispatchEvent(new Event('change',{bubbles:true}));}return;}
    const purchase=e.target.closest('[data-dr-submit]');
    if(purchase){submitProduct(purchase.form,e);return;}
    const cartSubmit=e.target.closest('[data-dr-cart] button[type=submit]');
    if(cartSubmit){submitCart(cartSubmit.form,cartSubmit,e);return;}
    const link=e.target.closest('[data-dr-cart-link],.dr-remove-item');
    if(link&&!e.metaKey&&!e.ctrlKey&&!e.shiftKey&&e.button===0){e.preventDefault();e.stopImmediatePropagation();location.assign(link.href);}
  },true);
  document.addEventListener('keydown',e=>{if(e.key==='Escape')document.querySelectorAll('.dr-mobile-menu[open],.dr-nav-dropdown[open]').forEach(d=>{d.open=false;d.querySelector('summary')?.focus();});});
  window.addEventListener('pageshow',e=>{if(e.persisted)location.reload();});
})();

// Preserve native size/price/availability/sort filters when changing one color.
document.addEventListener('click',function(e){
  const link=e.target.closest('[data-dr-color-link]');
  if(!link||e.button!==0||e.ctrlKey||e.metaKey||e.shiftKey||e.altKey)return;
  const destination=new URL(link.href);
  const current=new URL(location.href);
  current.searchParams.delete('page');
  destination.search=current.search;
  e.preventDefault();location.assign(destination.href);
});

// DREAM complete-the-set: separate from the main product form; adds joggers without leaving the page.
(()=>{
  const norm=s=>String(s||'').toLowerCase().replace(/\s+/g,'').replace('xxxl','3xl').replace('xxl','2xl').replace('3x-large','3xl').replace('2x-large','2xl').replace('4x-large','4xl');
  const setup=root=>{
    if(root.dataset.drPairReady)return;root.dataset.drPairReady='true';
    const sizes=[...root.querySelectorAll('[data-dr-pair-size]')],btn=root.querySelector('[data-dr-pair-add]'),status=root.querySelector('[data-dr-pair-status]');
    let manual=false;
    const pick=(b,byUser)=>{sizes.forEach(x=>x.setAttribute('aria-pressed',String(x===b)));if(byUser)manual=true;status.textContent='';};
    sizes.forEach(b=>b.addEventListener('click',()=>pick(b,true)));
    // Pre-match the jogger size to the size chosen for the top (until the shopper picks one).
    const pdp=root.closest('[data-dr-product]'),main=pdp&&pdp.querySelector('[data-dr-variant]');
    if(main)main.addEventListener('change',()=>{
      if(manual)return;const label=main.options[main.selectedIndex]?.text||'';const size=norm(label.split('/')[0]);
      const hit=sizes.find(b=>!b.disabled&&norm(b.dataset.size)===size);if(hit)pick(hit,false);
    });
    btn.addEventListener('click',async()=>{
      const chosen=sizes.find(b=>b.getAttribute('aria-pressed')==='true');
      if(!chosen){status.textContent=btn.dataset.choose;sizes.find(b=>!b.disabled)?.focus();return;}
      if(btn.getAttribute('aria-busy')==='true')return;
      btn.setAttribute('aria-busy','true');btn.querySelector('span').textContent=btn.dataset.adding;
      try{
        const r=await fetch(btn.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(chosen.dataset.drPairSize),quantity:1}]})});
        const data=await r.json();if(!r.ok)throw new Error(data.description||data.message||'');
        status.innerHTML='';status.append(btn.dataset.added+' '+chosen.textContent.trim()+'. ');
        const a=document.createElement('a');a.href=btn.dataset.cart;a.textContent=btn.dataset.view;status.append(a);
        const c=await (await fetch('/cart.js',{headers:{'Accept':'application/json'}})).json();
        document.querySelectorAll('[data-dr-cart-count]').forEach(n=>n.textContent=c.item_count-c.items.filter(i=>i.handle==='dream-shipping-protection').reduce((a,i)=>a+i.quantity,0));
      }catch(e){status.textContent=e.message||'Something went wrong. Please try again.';}
      finally{btn.removeAttribute('aria-busy');btn.querySelector('span').textContent=btn.dataset.label;}
    });
  };
  const init=s=>s.querySelectorAll('[data-dr-pair]').forEach(setup);
  document.addEventListener('DOMContentLoaded',()=>init(document));
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();
